import { render, staticRenderFns } from "./DiscourseSSOPage.vue?vue&type=template&id=7d3ed827&scoped=true&"
import script from "./DiscourseSSOPage.vue?vue&type=script&lang=js&"
export * from "./DiscourseSSOPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscourseSSOPage.vue?vue&type=style&index=0&id=7d3ed827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3ed827",
  null
  
)

export default component.exports